/* CategorySection.tsx generated by @compiled/babel-plugin v0.36.0 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { Hide, media, Show } from '@atlaskit/primitives/responsive';
import { TileClickedEvent, useAnalyticsEvents } from '@atlassian/mpac-analytics';
import { H3 } from '@atlassian/mpac-primitives';
import { useHistory, usePageRouteSourceProvider } from '@atlassian/mpac-ui';
import React from 'react';
import { categories } from './constants';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const _55 = "._k48p1fw0{font-weight:700}";
const _54 = "@media not all and (min-width:64rem){._2osnxy5q{gap:var(--ds-space-400,2pc)}._6ssjwcbu{padding:var(--_4thsry)}._159e1fhb{align-self:stretch}}";
const _53 = "@media not all and (min-width:48rem){._8164pxbi{gap:var(--ds-space-200,1pc)}._15txwcbu{padding:var(--_4thsry)}._1tvd1fhb{align-self:stretch}}";
const _52 = "._1bsb1osq{width:100%}";
const _51 = "._2lx21bp4{flex-direction:column}";
const _50 = "._1yt41gtx{padding:var(--_1bm102r)}";
const _49 = "._zulpxy5q{gap:var(--ds-space-400,2pc)}";
const _48 = "._1bsb1ris{width:max-content}";
const _47 = "._p12f1rpl{max-width:47rem}";
const _46 = "._u5f31ejb{padding-right:var(--ds-space-300,24px)}";
const _45 = "._19bvu2gc{padding-left:var(--ds-space-100,8px)}";
const _44 = "._2lx2vrvc{flex-direction:row}";
const _43 = "._n3tdu2gc{padding-bottom:var(--ds-space-100,8px)}";
const _42 = "._1reo1wug{overflow-x:auto}";
const _41 = "._18u012du{margin-left:calc(-50vw + 50%)}";
const _40 = "._1bsbauwl{width:100vw}";
const _39 = "._1e0c1ule{display:block}";
const _38 = "@media not all and (min-width:64rem){._2osnpxbi{gap:var(--ds-space-200,1pc)}._6ssjirkd{padding:var(--_12zv94d)}._1s4p1osq{width:100%}._159e1fhb{align-self:stretch}}";
const _37 = "._1n261g80{flex-wrap:wrap}";
const _36 = "._ae4v1h6o{align-content:center}";
const _35 = "._p12f1n7t{max-width:72rem}";
const _34 = "._1bsbbaqh{width:61.5rem}";
const _33 = "._zulppxbi{gap:var(--ds-space-200,1pc)}";
const _32 = "@media not all and (min-width:64rem){._so7doxwj{font-size:.875rem}}";
const _31 = "._y3gn1h6o{text-align:center}";
const _30 = "._vwz41k8s{line-height:1.5rem}";
const _29 = "._syaz1fxt{color:var(--ds-text,#172b4d)}";
const _28 = "._k48p1nn1{font-weight:400}";
const _27 = "._1wybpxbi{font-size:var(--ds-space-200,1pc)}";
const _26 = "@media not all and (min-width:64rem){._tl281d98{padding-top:.8rem}._axwi1mvu{padding-right:.4rem}._1hwc9asb{padding-bottom:.6rem}._sp8t1mvu{padding-left:.4rem}._1s4p1jfw{width:var(--ds-space-500,40px)}._1kne1jfw{height:var(--ds-space-500,40px)}}";
const _25 = "@media not all and (min-width:48rem){._1kmx1mvu{padding-top:.4rem}._1ggm1mvu{padding-right:.4rem}._1ykz2eax{padding-bottom:.3rem}._1mae2eax{padding-left:.3rem}._1rfmxy5q{width:var(--ds-space-400,2pc)}._tnruxy5q{height:var(--ds-space-400,2pc)}}";
const _24 = "._4t3ioahv{height:var(--ds-space-600,3pc)}";
const _23 = "._1bsboahv{width:var(--ds-space-600,3pc)}";
const _22 = "._1e0c1txw{display:flex}";
const _21 = "._19bv1kwk{padding-left:.5rem}";
const _20 = "._n3td1d98{padding-bottom:.8rem}";
const _19 = "._u5f31kwk{padding-right:.5rem}";
const _18 = "._ca0q1j6v{padding-top:1rem}";
const _17 = "@media not all and (min-width:48rem){._15txpqxz{padding:var(--_1rw1tzw)}._suga1txw{display:flex}}";
const _16 = "._j6xt108i:active{background:var(--ds-surface-hovered,#f1f2f4)}";
const _15 = "._1r9x1o36:active{outline-width:medium}";
const _14 = "._1ohyglyw:active{outline-style:none}";
const _13 = "._1q5t1r31:active{outline-color:currentColor}";
const _12 = "._19lc108i:hover{background:var(--ds-surface-hovered,#f1f2f4)}";
const _11 = "._y2mv12j9:focus{outline:var(--_toyvsf)}";
const _10 = "._1o9zidpf{flex-shrink:0}";
const _9 = "._80omtlke{cursor:pointer}";
const _8 = "._1bah1h6o{justify-content:center}";
const _7 = "._4cvr1h6o{align-items:center}";
const _6 = "._1e0c116y{display:inline-flex}";
const _5 = "._2rko1kwk{border-radius:.5rem}";
const _4 = "._19itpp12{border:var(--_18x9sjc)}";
const _3 = "._11q7vuon{background:var(--ds-surface,#fff)}";
const _2 = "._1yt4pqxz{padding:var(--_1rw1tzw)}";
const _ = "._zulpu2gc{gap:var(--ds-space-100,8px)}";
const ANALYTICS_SUBJECT_ID_CATEGORY_SECTION_TILE = 'categorySectionTile';
const sectionContainerStyle = null;
const H3Style = null;
const desktopTabletLayoutStyle = null;
const mobileGridContainerStyle = null;
const mobileGridWrapperStyle = null;
const categoryCardStyle = null;
const categoryIconStyle = null;
const categoryNameStyle = null;
export const CategorySection = () => {
  const history = useHistory();
  const fireEvent = useAnalyticsEvents();
  const {
    setPageRouteSource
  } = usePageRouteSourceProvider();
  const handleCategoryTileClick = (href, categoryName) => {
    setPageRouteSource('homeCategorySection');
    fireEvent({
      eventType: TileClickedEvent,
      actionSubjectId: ANALYTICS_SUBJECT_ID_CATEGORY_SECTION_TILE,
      attributes: {
        categoryName
      }
    });
    history === null || history === void 0 ? void 0 : history.push(href);
  };
  const handleKeyDown = (event, href, categoryName) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleCategoryTileClick(href, categoryName);
    }
  };
  const renderCategoryCard = category => {
    const categoryUrl = "/categories/".concat(category.id);
    return /*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17]
      }), /*#__PURE__*/_jsxs("div", {
        onClick: () => handleCategoryTileClick(categoryUrl, category.name),
        onKeyDown: event => handleKeyDown(event, categoryUrl, category.name),
        role: "button",
        tabIndex: 0,
        "aria-label": "Explore ".concat(category.name, " apps"),
        className: ax(["_zulpu2gc _1yt4pqxz _11q7vuon _19itpp12 _2rko1kwk _1e0c116y _4cvr1h6o _1bah1h6o _80omtlke _1o9zidpf _y2mv12j9 _19lc108i _1q5t1r31 _1ohyglyw _1r9x1o36 _j6xt108i _15txpqxz _suga1txw"]),
        style: {
          "--_1rw1tzw": ix("var(--ds-space-050, 4px)".concat(" ", "var(--ds-space-300, 24px)", " ", "var(--ds-space-050, 4px)", " ", "var(--ds-space-200, 16px)")),
          "--_18x9sjc": ix("1px solid ".concat("var(--ds-border, #091E4224)")),
          "--_toyvsf": ix("2px solid ".concat("var(--ds-border-focused, #388BFF)"))
        },
        children: [/*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_18, _19, _20, _21, _22, _23, _24, _8, _7, _25, _26]
          }), /*#__PURE__*/_jsx("img", {
            src: category.icon,
            alt: "",
            className: ax(["_ca0q1j6v _u5f31kwk _n3td1d98 _19bv1kwk _1e0c1txw _1bsboahv _4t3ioahv _1bah1h6o _4cvr1h6o _1kmx1mvu _1ggm1mvu _1ykz2eax _1mae2eax _1rfmxy5q _tnruxy5q _tl281d98 _axwi1mvu _1hwc9asb _sp8t1mvu _1s4p1jfw _1kne1jfw"])
          })]
        }), /*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_27, _28, _29, _30, _31, _32]
          }), /*#__PURE__*/_jsx("span", {
            className: ax(["_1wybpxbi _k48p1nn1 _syaz1fxt _vwz41k8s _y3gn1h6o _so7doxwj"]),
            children: category.name
          })]
        })]
      }, category.id)]
    }, category.id);
  };
  const renderDesktopTabletView = /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_33, _22, _34, _35, _36, _8, _37, _7, _38]
    }), /*#__PURE__*/_jsx("div", {
      className: ax(["_zulppxbi _1e0c1txw _1bsbbaqh _p12f1n7t _ae4v1h6o _1bah1h6o _1n261g80 _4cvr1h6o _2osnpxbi _6ssjirkd _1s4p1osq _159e1fhb"]),
      style: {
        "--_12zv94d": ix("0 ".concat("var(--ds-space-500, 40px)"))
      },
      children: categories.map(renderCategoryCard)
    })]
  });
  const renderMobileView = /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_39, _40, _41, _42, _43]
    }), /*#__PURE__*/_jsx("div", {
      className: ax(["_1e0c1ule _1bsbauwl _18u012du _1reo1wug _n3tdu2gc"]),
      children: /*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_33, _22, _44, _37, _45, _46, _47, _48]
        }), /*#__PURE__*/_jsx("div", {
          className: ax(["_zulppxbi _1e0c1txw _2lx2vrvc _1n261g80 _19bvu2gc _u5f31ejb _p12f1rpl _1bsb1ris"]),
          children: categories.map(renderCategoryCard)
        })]
      })
    })]
  });
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_49, _50, _22, _51, _7, _52, _53, _54]
    }), /*#__PURE__*/_jsxs("div", {
      className: ax(["_zulpxy5q _1yt41gtx _1e0c1txw _2lx21bp4 _4cvr1h6o _1bsb1osq _8164pxbi _15txwcbu _1tvd1fhb _2osnxy5q _6ssjwcbu _159e1fhb"]),
      style: {
        "--_1bm102r": ix("var(--ds-space-500, 40px)".concat(" 0")),
        "--_4thsry": ix("var(--ds-space-300, 24px)".concat(" 0"))
      },
      children: [/*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_55, _31]
        }), /*#__PURE__*/_jsx(H3, {
          as: "h2",
          className: ax(["_k48p1fw0 _y3gn1h6o"]),
          children: "Explore top categories"
        })]
      }), /*#__PURE__*/_jsx(Show, {
        above: "sm",
        children: renderDesktopTabletView
      }), /*#__PURE__*/_jsx(Hide, {
        above: "sm",
        children: renderMobileView
      })]
    })]
  });
};